import React from "react";
import { ReadMoreWrapper } from "@Modules/common/ReadMoreWrapper";
import { IAboutEvent } from "./IAboutEvent";
import commonStyles from "../commonStyles.module.scss";

const AboutEvent = ({
    hideComponent,
    minifyEventDescription,
    descMaxLength,
    hideAboutEventHeader,
    aboutEventHeader,
    hideEventDescription,
    eventDescription,
    offeringIsRecommended,
}: IAboutEvent.IProps): JSX.Element | null => {
    if (hideComponent) return null;

    const showReadMoreFunctionality =
        minifyEventDescription && eventDescription.length > descMaxLength;

    const appointmentDescription = (
        <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: eventDescription,
            }}
            className={commonStyles.detailsSectionBody}
        />
    );

    const processedEventDescription = (
        <>
            {showReadMoreFunctionality ? (
                <ReadMoreWrapper
                    id="Appointment_description"
                    collapsedHeight={150}
                    buttonClassName="mt-2"
                >
                    {appointmentDescription}
                </ReadMoreWrapper>
            ) : (
                appointmentDescription
            )}
        </>
    );

    return (
        <div className={commonStyles.detailsSection}>
            <div className={commonStyles.detailsSectionBody}>
                {hideAboutEventHeader ? null : (
                    <div className={commonStyles.detailsSectionTitle}>
                        {aboutEventHeader}
                        {offeringIsRecommended ? (
                            <span
                                className={commonStyles.recommendedLabelField}
                            >
                                Recommended
                            </span>
                        ) : null}
                    </div>
                )}
                {hideEventDescription ? null : processedEventDescription}
            </div>
        </div>
    );
};
export default AboutEvent;
